export const CDN_URL = 'https://cdn.tstark2.us/randomizer';
export const COLLECTIONS_WITH_CHALLENGES = [
  'Guardians of the Galaxy Remix',
  'Rise of the Black Panther',
  'Tales of Asgard',
  'Enter the Spider-Verse'
];
